import './App.css';

const servicios = [
  'Solera mecanizada semiseca para viviendas y locales comerciales',
  'Nivelación precisa según cotas y requisitos técnicos del proyecto',
  'Superficie compacta, resistente y lista para todo tipo de acabados',
  'Ejecución rápida con control del secado y acabados profesionales',
];

const proyectos = [
  {
    titulo: 'Interiores residenciales',
    descripcion:
      'Soluciones limpias, rectas y uniformes para salones, cocinas y estancias de alto tránsito.',
  },
  {
    titulo: 'Terrazas y exteriores',
    descripcion:
      'Base sólida y duradera para espacios exteriores, con excelente planeidad y resistencia.',
  },
  {
    titulo: 'Obra nueva y reformas',
    descripcion:
      'Adaptamos cada ejecución a las necesidades técnicas del proyecto y los tiempos de la obra.',
  },
];

const galeria = [
  {
    src: '/media/trabajo-01.jpg',
    alt: 'Solera terminada en zona de piscina con acabado uniforme',
  },
  {
    src: '/media/trabajo-02.jpg',
    alt: 'Acabado exterior de solera con desnivel técnico y drenaje',
  },
  {
    src: '/media/trabajo-03.jpg',
    alt: 'Plataforma exterior acabada junto a vivienda',
  },
  {
    src: '/media/trabajo-04.jpg',
    alt: 'Ejecución interior de solera semiseca sobre gran superficie',
  },
  {
    src: '/media/trabajo-05.jpg',
    alt: 'Solera en terraza residencial con alta planeidad',
  },
  {
    src: '/media/trabajo-06.jpg',
    alt: 'Acabado de solera en zona de ventanal y cambio de nivel',
  },
  {
    src: '/media/trabajo-07.jpg',
    alt: 'Compactación y fratasado de solera mecanizada semiseca',
  },
  {
    src: '/media/trabajo-08.jpg',
    alt: 'Detalle de superficie final de solera lisa y uniforme',
  },
  {
    src: '/media/trabajo-09.jpg',
    alt: 'Obra interior en gran nave con solera de alta resistencia',
  },
  {
    src: '/media/trabajo-10.jpg',
    alt: 'Solera semiseca en proyecto técnico con instalaciones de suelo radiante',
  },
];

function App() {
  return (
    <div className="site" lang="es">
      <header className="hero" id="inicio">
        <nav className="topbar" aria-label="Navegación principal">
          <a href="#inicio" className="brand">
            ROYAL CHAPE
          </a>
          <div className="topbar-right">
            <div className="nav-links" aria-label="Enlaces de sección">
              <a href="#servicios" className="nav-link">
                Servicios
              </a>
              <a href="#proyectos" className="nav-link">
                Aplicaciones
              </a>
              <a href="#galeria" className="nav-link">
                Galería
              </a>
              <a href="#contacto" className="nav-link">
                Contacto
              </a>
            </div>
            <a className="top-contact" href="tel:+34675405762">
              +34 675 405 762
            </a>
          </div>
        </nav>

        <div className="hero-content">
          <div className="hero-text">
            <p className="eyebrow">La solera es nuestro arte. En acción desde 2020.</p>
            <h1>Solera mecanizada semiseca – Royal CHAPE</h1>
            <p className="lead">Soleras rectas, sólidas y listas para durar.</p>
            <p>
              Royal CHAPE ofrece servicios profesionales de ejecución de solera mecanizada semiseca,
              realizados con precisión, rapidez y altos estándares de calidad en proyectos residenciales
              y comerciales en España.
            </p>
            <div className="hero-cta">
              <a href="tel:+34675405762" className="cta-btn primary">
                Llamar ahora
              </a>
              <a href="mailto:royal.chape@gmail.com" className="cta-btn secondary">
                royal.chape@gmail.com
              </a>
            </div>
          </div>

          <aside className="hero-card" aria-label="Contacto principal">
            <img
              className="logo"
              src="/media/royal-chape-logo.jpg"
              alt="Logo de Royal CHAPE Professional"
            />
            <h2>Contacto rápido</h2>
            <p>
              <strong>ROYAL CHAPE — recto, sólido, regio.</strong>
            </p>
            <p>
              <a href="tel:+34675405762">+34 675 405 762</a>
            </p>
            <p>
              <a href="mailto:royal.chape@gmail.com">royal.chape@gmail.com</a>
            </p>
            <p>
              TikTok: <strong>royal_chape</strong>
            </p>
          </aside>
        </div>
      </header>

      <main>
        <section className="section" id="servicios">
          <h2>Especialistas en solera mecanizada semiseca</h2>
          <p>
            Utilizamos equipos especializados y materiales cuidadosamente seleccionados para garantizar
            una superficie perfectamente nivelada, compacta y duradera, lista para cualquier tipo de
            acabado.
          </p>
          <ul className="list">
            {servicios.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="section alt" id="tecnologia">
          <h2>Tecnología semiseca: eficiencia y resistencia</h2>
          <p>
            La tecnología semiseca permite un secado controlado, alta resistencia mecánica y tiempos de
            ejecución reducidos, siendo ideal tanto para construcciones residenciales como para proyectos
            comerciales. Cada obra se realiza con atención al detalle, respetando las cotas, la planeidad
            y los requisitos técnicos del proyecto.
          </p>
        </section>

        <section className="section" id="proyectos">
          <h2>Aplicaciones habituales</h2>
          <div className="cards">
            {proyectos.map((proyecto) => (
              <article className="card" key={proyecto.titulo}>
                <h3>{proyecto.titulo}</h3>
                <p>{proyecto.descripcion}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section" id="galeria">
          <h2>Galería de trabajos realizados</h2>
          <p>
            Proyectos reales de Royal CHAPE en obra residencial y comercial. Acabados precisos, nivelados
            y listos para la fase final del proyecto.
          </p>
          <div className="gallery-grid" role="list" aria-label="Trabajos finalizados de Royal CHAPE">
            {galeria.map((foto) => (
              <figure className="gallery-item" key={foto.src} role="listitem">
                <img src={foto.src} alt={foto.alt} loading="lazy" />
              </figure>
            ))}
          </div>
        </section>
      </main>

      <footer className="footer" id="contacto">
        <h2>ROYAL CHAPE — recto, sólido, regio.</h2>
        <p>Solicita presupuesto sin compromiso.</p>
        <p>
          <a href="tel:+34675405762">+34 675 405 762</a> ·{' '}
          <a href="mailto:royal.chape@gmail.com">royal.chape@gmail.com</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
